module.exports = __webpack_public_path__ + "static/media/4ll25.53a12172.png";